
export const END_DATE = '2024-05-01T00:00:00';

export const COLORS = [
  "#FCBC05",
  "#4385F5",
  "#E5443F",
  "#34A853",
  "#EDEDED"
];